// Teile ausblenden — Planungswerkzeug, persistiert in part.meta.hidden.
// Stückliste/Zuschnittplan zählen verdeckte Teile weiter mit. Engine-frei.
// Nur true wird gespeichert; ein leerer Schlüssel wird weggelassen
// (Muster: cutouts.js/miters.js).

export function isHidden(part) {
  return part?.meta?.hidden === true
}

// Neues meta mit gesetztem bzw. entferntem hidden-Schlüssel
export function withHidden(part, hidden) {
  const meta = { ...part.meta }
  if (hidden) meta.hidden = true
  else delete meta.hidden
  return meta
}

// Updates fürs Isolieren: alle Teile außerhalb der Auswahl ausblenden
// (bereits versteckte bleiben unangetastet — nichts doppelt im Undo)
export function isolateUpdates(parts, keepIds) {
  const keep = new Set(keepIds)
  return parts
    .filter((part) => !keep.has(part.client_id) && !isHidden(part))
    .map((part) => ({ clientId: part.client_id, attrs: { meta: withHidden(part, true) } }))
}

// Updates für „Alle einblenden“: jedes versteckte Teil wieder sichtbar machen
export function showAllUpdates(parts) {
  return parts
    .filter((part) => isHidden(part))
    .map((part) => ({ clientId: part.client_id, attrs: { meta: withHidden(part, false) } }))
}
